import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { closeSidebar, openSidebar, setCurrentlyOpenFeature } from 'src/modules/App/actions'
import { getFromSettings, isAfterHours } from 'src/utils/helpers'
import Sidebar from './Sidebar'

const mapStateToProps = state => {
  const afterHours = getFromSettings(state, 'afterHours')
  const timeZone = parseFloat(getFromSettings(state, 'timeZone', 0))
  return {
    isSidebarVisible: state.appReducer.isSidebarVisible,
    isChatOnlyFeature: state.appReducer.isChatOnlyFeature,
    features: getFromSettings(state, 'features', {}),
    featuresAndOptions: state.appReducer.features,
    chatOptions: getFromSettings(state, 'chatOptions', {}),
    isAfterHours: isAfterHours(afterHours, timeZone),
    isChatEmpty: state.chat.isChatEmpty,
    areAppActionsDisabled: state.nonPersistentAppReducer.areAppActionsDisabled,
    bannerNotification: getFromSettings(state, 'bannerNotification', {}),
    isNotificationHidden: state.appReducer.isNotificationHidden,
    notificationHeight: state.appReducer.notificationHeight,
    brand: getFromSettings(state, 'brand', {}),
    pageBackground: state.appReducer.settings.brand.colors.backgroundColor,
  }
}

const mapDispatchToProps = {
  closeSidebar,
  openSidebar,
  setCurrentlyOpenFeature,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar))
